import {reader} from "messaging/reader.js";
import {publish} from "messaging/queue.js";
import {doc} from './documentation.js';
import StepData from 'pattern/StepData.js';
import {trigger, filter, lazy} from './lang.js';
import {trig} from './trig.js';

const DEFAULT_STEP = new StepData();

export const send = (type, value) => {
    return (... args) => {
        let [stepData, time, stepNumber] = args;
        if (stepData) {
            let _type = lazy(type, ...args);
            let _value = lazy(value, ...args);
            publish(_type, _value);
        }
        return filter(true);
    };
};

doc(
    "receive",
    {
        "type":"",
        "fn":"",
        "skipEmpty":"",
    },
    "Reads messages of given type returning the values");
export const receive = (type, fn, skipEmpty=true) => {
    let _reader = reader(type);
    let last = undefined;

    return (... args) => {
        let stepData = args[0] && args[0].track ? args[0] : undefined;
        if (!stepData && skipEmpty) {
            // dont read unless we have a trigger here
            return undefined; 
        }
        let msgs = _reader();
        if (fn) {
            if (msgs.length > 0 && stepData === undefined) {
                let effect = args[3];
                let _stepData = effect.getStep(DEFAULT_STEP);
                _stepData.track = effect.track;
                args = [_stepData, ...args.slice(1)];
            } 
            let r = msgs.map((value) => {
                if (typeof fn === "function") {
                    return lazy(fn(value), ...args);
                } else {
                    // in the case of receive("msg", chop(5))
                    // chop(5) expands to an axiom
                    return fn;
                }
            });
            let x = r[0] || trig(args);
            return x;
        }
        let ret = msgs.length === 0 ? last : msgs;
        if (msgs.length > 0) {
            last = msgs;
        }
        return ret[0];
    };
};
